module.exports = __webpack_public_path__ + "assets/fonts/GothamProNarrow-Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamProNarrow-Medium.eot
// module id = 1911
// module chunks = 0